import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, switchMap, tap } from 'rxjs';
import { FeedSourceService } from '../services/api/feed-source.service';
import { MainFeedService } from '../services/api/main-feed.service';
import { MainFeed } from '../models/feed.model';

export const editFeedResolver: ResolveFn<MainFeed> = (route, _) => {
    const mainFeedService = inject(MainFeedService);
    const feedSourceService = inject(FeedSourceService);
    return mainFeedService.getMainFeedById(route.params['id']).pipe(
        tap(mainFeed => {
            feedSourceService.setFeedSourceUrl(mainFeed.sourceUrl);
            feedSourceService.setPreviewSourceId(mainFeed.previewSourceId);
            feedSourceService.setRootArrayPath(mainFeed.rootArrayPath);
        }),

        switchMap(mainFeed => feedSourceService.getJsonSchema(mainFeed.rootArrayPath).pipe(map(() => mainFeed)))
    );
};
